import React, { useState, useEffect } from "react";
import { Row, Col, Form } from "reactstrap";
import UserSettings from "../../components/UserSettings/UserSettings";
import BillingDetails from "../../components/CheckoutForms/BillingDetails/BillingDetails";
import ShippingDetails from "../../components/CheckoutForms/ShippingDetails/ShippingDetails";
import { v4 } from "uuid";
import UserSettingsTitle from "../../components/UserSettings/UserSettingsTitle/UserSettingsTitle";
import { localUser } from "../../assets/Helpers";
import { useQuery } from "@apollo/react-hooks";
import { USER_ADDRESS_DATA } from "../../queries/userAdressQuery";

import "../../styles/general/_form.scss";

const Address = () => {
  const userInfo = localUser();

  const [addressData, setAddressData] = useState({
    billing: {
      firstName: "",
      lastName: "",
      company: "",
      city: "",
      address: "",
      country: "XK",
      apartment: "",
      telephone: "",
      email: "",
      isLoaded: false,
    },
    shipping: {
      firstName: "",
      lastName: "",
      company: "",
      city: "",
      address: "",
      apartment: "",
      telephone: "",
      email: "",
      comment: "",
      differentShipping: true,
      isLoaded: false,
    },
    isValid: false,
  });

  const [mutationData, setMutationData] = useState(null);
  const [mutationLoading, setMutationLoading] = useState(false);

  const { data: customerAddressData } = useQuery(USER_ADDRESS_DATA);

  const address = async (input) => {
    setMutationLoading(true);
    try {
      // TODO: Add update address endpoint
      // await api.updateCustomerAddress(input);
      setMutationData({ success: true });
    } catch (error) {
      console.error("Error updating address:", error);
    } finally {
      setMutationLoading(false);
    }
  };

  // Update addressData from API response
  useEffect(() => {
    if (customerAddressData?.customer && !addressData.billing.isLoaded) {
      const billingInfo = customerAddressData.customer.billing;
      const shippingInfo = customerAddressData.customer.shipping;
      
      if (billingInfo) {
        setAddressData({
          ...addressData,
          billing: {
            ...addressData.billing,
            firstName: billingInfo.firstName || "",
            lastName: billingInfo.lastName || "",
            company: billingInfo.company || "",
            city: billingInfo.city || "",
            country: billingInfo.country || "XK",
            address: billingInfo.address1 || "",
            apartment: billingInfo.address2 || "",
            telephone: billingInfo.phone || "",
            email: billingInfo.email || "",
            isLoaded: true,
          },
          shipping: {
            ...addressData.shipping,
            firstName: shippingInfo?.firstName || billingInfo.firstName || "",
            lastName: shippingInfo?.lastName || billingInfo.lastName || "",
            company: shippingInfo?.company || billingInfo.company || "",
            city: shippingInfo?.city || billingInfo.city || "",
            address: shippingInfo?.address1 || billingInfo.address1 || "",
            apartment: shippingInfo?.address2 || billingInfo.address2 || "",
            telephone: shippingInfo?.phone || billingInfo.phone || "",
            email: shippingInfo?.email || billingInfo.email || "",
            isLoaded: true,
          },
        });
      }
    }
  }, [customerAddressData]);

  const handleBillingChange = (name, value) => {
    setAddressData({
      ...addressData,
      billing: {
        ...addressData.billing,
        [name]: value,
      },
    });
  };

  const handleShippingChange = (name, value) => {
    setAddressData({
      ...addressData,
      shipping: {
        ...addressData.shipping,
        [name]: value,
      },
    });
  };

  const handleCheckoutSubmit = (e) => {
    e.preventDefault();

    const { billing, shipping } = addressData;
    address({
      id: userInfo.ID,
      billing: {
        firstName: billing.firstName,
        lastName: billing.lastName,
        phone: billing.telephone,
        address1: billing.address,
        address2: billing.apartment,
        company: billing.company,
        state: "AL",
        country: billing.country,
        city: billing.city,
        email: billing.email,
      },
      shipping: {
        firstName: shipping.firstName,
        lastName: shipping.lastName,
        address1: shipping.address,
        address2: shipping.apartment,
        company: shipping.company,
        state: "XK",
        country: "XK",
        city: shipping.city,
      },
    });
  };

  return (
    <div className="Profile">
      <UserSettings>
        <UserSettingsTitle title="Perditëso Adresat" />
        <Form
          onSubmit={(e) => {
            handleCheckoutSubmit(e);
          }}
        >
          <Row>
            <Col xs="12" sm="12" lg="6">
              <BillingDetails
                details={addressData.billing}
                onChange={(name, value) => handleBillingChange(name, value)}
              />
            </Col>
            <Col xs="12" sm="12" lg="6">
              <ShippingDetails
                details={addressData.shipping}
                shippingTitle={true}
                onChange={(name, value) => handleShippingChange(name, value)}
              />
            </Col>
          </Row>
          <div className="GeneralForm__input">
            <input value="Përditëso të dhënat" type="submit" />
          </div>
        </Form>
      </UserSettings>
    </div>
  );
};

export default Address;
